import React from 'react';
import { Grid } from '@material-ui/core';
import CompareLogsFilters from 'features/wells/corrosion/components/CompareLogsFilters';
import { NavTabsContainer } from 'altus-ui-components';
import SystemRoutesContainer from 'app/components/SystemRoutesContainer';
import withStyles from '@material-ui/styles/withStyles';

const CompareLogsContainer = ({ routes, classes, wellboreId }) => {
  return (
    <Grid container>
      <Grid item xs={12}>
        <CompareLogsFilters wellboreId={wellboreId} />
      </Grid>
      <Grid xs={12} item className={classes.navContainer}>
        <NavTabsContainer
          routes={routes}
          indicatorColor="primary"
          disableUnderline={true}
        />
      </Grid>

      <SystemRoutesContainer routes={routes} />
    </Grid>
  );
};

const styles = (theme) => ({
  navContainer: {
    marginBottom: theme.spacing(3),
  },
});

export default withStyles(styles)(CompareLogsContainer);
